import angular from 'angular';

angular.module('cloudX').filter('newLineTextToRichText', [
  '$sce',
  function($sce) {
    return function(input) {
      if (input) {
        if (!input.includes('<html') && !input.includes('<body>')) {
          var converted = input.replace(/(?:\r\n|\r|\n)/g, '<br />');
          return $sce.trustAsHtml(converted);
        }
      }
      return $sce.trustAsHtml(input);
    };
  },
]);
